export default __webpack_public_path__ + "static/media/watch-icon-blue.b1b9cca2.svg";